const STORAGE_KEY = 'comment_edit_tokens';

const isBrowser = () =>
    typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const readStore = () => {
    if (!isBrowser()) {
        return {};
    }
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return {};
        }
        return JSON.parse(raw);
    } catch {
        return {};
    }
};

const writeStore = (data) => {
    if (!isBrowser()) {
        return;
    }
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

const isExpired = (expiresAt) => {
    if (!expiresAt) {
        return false;
    }
    const expires = new Date(expiresAt).getTime();
    if (Number.isNaN(expires)) {
        return true;
    }
    return Date.now() > expires;
};

export const saveCommentToken = (commentId, token, expiresAt) => {
    if (!commentId || !token) {
        return;
    }
    const store = readStore();
    store[commentId] = {
        token,
        expiresAt
    };
    writeStore(store);
};

export const getCommentToken = (commentId) => {
    if (!commentId) {
        return null;
    }
    const store = readStore();
    const entry = store[commentId];
    if (!entry) {
        return null;
    }
    if (isExpired(entry.expiresAt)) {
        delete store[commentId];
        writeStore(store);
        return null;
    }
    return entry;
};

export const removeCommentToken = (commentId) => {
    if (!commentId) {
        return;
    }
    const store = readStore();
    if (store[commentId]) {
        delete store[commentId];
        writeStore(store);
    }
};

export const purgeExpiredCommentTokens = () => {
    const store = readStore();
    let mutated = false;
    Object.keys(store).forEach((key) => {
        if (isExpired(store[key]?.expiresAt)) {
            delete store[key];
            mutated = true;
        }
    });
    if (mutated) {
        writeStore(store);
    }
};
